import { render, staticRenderFns } from "./UploadLinksHistory.vue?vue&type=template&id=fa96d848&scoped=true"
import script from "./UploadLinksHistory.vue?vue&type=script&lang=js"
export * from "./UploadLinksHistory.vue?vue&type=script&lang=js"
import style0 from "./UploadLinksHistory.vue?vue&type=style&index=0&id=fa96d848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa96d848",
  null
  
)

export default component.exports